export default __webpack_public_path__ + "static/media/Contact.218fd2be.svg";